import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcDate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 4v2h12V4h2v2h4v22H4V6h4V4h2Zm16 10H6v12h20V14Zm-4-6H10v2H8V8H6v4h20V8h-2v2h-2V8Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcDate;
